import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { EnrichData } from '../types';
import { getCookie } from '../utils';
var EnrichExperiment = /*#__PURE__*/_createClass(function EnrichExperiment(name, value) {
  var _this = this;
  _classCallCheck(this, EnrichExperiment);
  _defineProperty(this, "name", void 0);
  _defineProperty(this, "value", void 0);
  // first check if value exists, get the value else assign empty string
  _defineProperty(this, "update", function () {
    _this.value = _this.value || getCookie(EnrichData.EXPERIMENT);
  });
  _defineProperty(this, "getEnrichValue", function () {
    return _this.value;
  });
  this.name = name;

  // checking for undefined to pass null/empty string/0
  if (value !== undefined) {
    this.value = value;
  }
});
export { EnrichExperiment as default };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/rio2-web-client/dist/esm/enrich/enrichExperiment.js
// module id = 4150
// module chunks = 11